module.exports = __webpack_public_path__ + "img/other_pay_googlepay.cd265a37.svg";